import React from 'react';
import classNames from 'classnames';
import css from './BlueLayout.module.css';
import { useAuthBtn } from '../use-auth-btn';
import { Logo } from '../../../../../layout/BotBuilderSidebar/Logo/Logo';
import { LoginLikeLayout } from './LoginLikeLayout';
import { SignUpLikeLayout } from './SingUpLikeLayout';
import { G2BadgeTop50, MetaBadge } from '@mm/icons';

type Props = {
  className?: string;
  children?: any;
  hideTrial?: boolean;
};

export const BlueLayout = ({ className, children, hideTrial }: Props) => {
  const { isSignIn, isLogIn, isResetPassword } = useAuthBtn();

  const isLoginLike = isSignIn || isLogIn || isResetPassword;

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.background}>
        <Logo className={css.desktopLogo} />
        <div className={css.left}>
          <div className={css.description}>
            {isLoginLike ? <LoginLikeLayout /> : <SignUpLikeLayout />}
          </div>
        </div>
        <div className={classNames(css.right)}>
          {isLoginLike && (
            <div className={css.badges}>
              <G2BadgeTop50 />
              <MetaBadge className={css.badge} />
            </div>
          )}
          <Logo
            className={classNames(css.logo, { [css.signupLogo]: !isLoginLike })}
          />
          {children}
        </div>
      </div>
    </div>
  );
};
